var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-tree',{attrs:{"options":_vm.options,"data":_vm.groupsTree}})}
var staticRenderFns = []

export { render, staticRenderFns }